import { ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { usePageTitle } from '@/hooks/use-page-title';
import { useMe } from '@/platform/auth/use-me';
import { usePresentVoiceText, useVoiceCopy } from '@/platform/voice/use-voice';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { adminTableFrameClassName } from '@/platform/features/admin-panel';
import { ProfilePageShell } from '@/platform/features/profile/profile-shared';
import { ADMIN_ROOT, platformAdminLinks } from '@/platform/lib/admin';

import { ProfileNoAccess } from './profile-no-access';

export function ProfileAdminPage() {
  usePageTitle('Verwaltung · Profil');
  const copy = useVoiceCopy();
  const present = usePresentVoiceText();
  const me = useMe();
  const adminLinks = me.data ? platformAdminLinks(me.data) : [];

  if (adminLinks.length === 0) {
    return <ProfileNoAccess />;
  }

  return (
    <ProfilePageShell>
      <PlatformPageHeader title="Verwaltung" description={copy('platform.profile.admin.intro')} />

      <Card>
        <CardHeader>
          <CardTitle>Verwaltung</CardTitle>
          <CardDescription>{copy('platform.profile.admin.intro')}</CardDescription>
        </CardHeader>
        <CardContent>
          <ul className={`${adminTableFrameClassName} divide-y divide-border`}>
            {adminLinks.map((link) => (
              <li key={link.id}>
                <Link
                  to={link.to}
                  className="flex items-center justify-between gap-3 px-3 py-3 text-sm hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
                >
                  <span>
                    <span className="block font-medium">{link.label}</span>
                    <span className="block text-muted-foreground">{present(link.description)}</span>
                  </span>
                  <ChevronRightIcon className="size-4 shrink-0 text-muted-foreground" aria-hidden />
                </Link>
              </li>
            ))}
          </ul>
          <Button asChild variant="link" className="mt-2 h-auto px-0">
            <Link to={ADMIN_ROOT}>Zur Verwaltung</Link>
          </Button>
        </CardContent>
      </Card>
    </ProfilePageShell>
  );
}
